import Spinner from "src/javascripts/components/utilities/Spinner";

export default function () {
  // Custom notifications dropdown, bootstrap has issues with clicking inside a dropdown
  // https://stackoverflow.com/questions/25089297/avoid-dropdown-menu-close-on-click-inside/25196101#25196101
  $(".PageActionFilterDropdown .toggleDropdown").on("click", function (e) {

    // Prevent default
    e.preventDefault();

    // Open menu
    $(this).closest(".PageActionFilterDropdown").toggleClass("show");
  });

  $("body").on("click", function (e) {
    // Set dropdown item
    let d = $(".PageActionFilterDropdown");

    // Don't close dropdown if clicking on filter tags or typeahead elements
    // BUT allow close button clicks to work
    if (
      $(e.target).hasClass("remove-temp-category") ||
      $(e.target).hasClass("filter-tag-close") ||
      $(e.target).closest(".remove-temp-category").length > 0 ||
      $(e.target).closest(".filter-tag-close").length > 0
    ) {
      // Allow close button clicks to propagate
      return false;
    }

    if (
      $(e.target).closest(".temp-category-tag").length > 0 ||
      $(e.target).closest(".temp-category-filter").length > 0 ||
      $(e.target).closest(".temp-categories-container").length > 0 ||
      $(e.target).closest(".selected-categories-container").length > 0 ||
      $(e.target).closest(".clear-all-categories").length > 0 ||
      $(e.target).closest(".twitter-typeahead").length > 0 ||
      $(e.target).closest(".tt-menu").length > 0
    ) {
      return;
    }

    // Remove open class if clicked outside the dropdown
    if (
      !d.is(e.target) &&
      d.has(e.target).length === 0 &&
      $(".show").has(e.target).length === 0
    ) {
      d.removeClass("show");
    }
  });
}
